import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiInvoiceMethodType {
    Email = 1,
    PostalAddress = 2,
}

export const fiInvoiceMethodTypes = [
    {
        id: fiInvoiceMethodType.Email,
        textId: 'common.email',
    },
    {
        id: fiInvoiceMethodType.PostalAddress,
        textId: 'common.postal_address',
    },
];

const fiInvoiceMethodTypesMap = createMap(fiInvoiceMethodTypes, 'id');
export function fiInvoiceMethodTypeName(invoiceMethodType: fiInvoiceMethodType, appText: AppTextService) {
    if (fiInvoiceMethodTypesMap.hasOwnProperty(invoiceMethodType))
        return appText.get(fiInvoiceMethodTypesMap[invoiceMethodType].textId);

    if (invoiceMethodType > 0) throw 'FI: unknown invoice method type "' + invoiceMethodType + '"';
}
